const normalizeCompareSeriesPointValue = (value) => {
	if (value == null) return null;
	if (typeof value === 'object' && 'value' in value) {
		if (value.value == null) return null;
		return Number(value.value) || 0;
	}
	return Number(value) || 0;
};

export const resolveCompareSeriesPointValueAt = (values = [], dataIndex) => {
	if (dataIndex == null || dataIndex < 0) return null;
	return normalizeCompareSeriesPointValue(values[dataIndex]);
};

/** 柱+折混合：悬停柱/折线分别只展示当前系列，避免轴触发时四系列堆叠 */
export const buildMixedCompareItemTooltip = (chartTheme, { seriesDefs = [], formatSeriesValue }) => ({
	...chartTheme.tooltip,
	trigger: 'item',
	confine: true,
	formatter: (params) => {
		if (!params) return '';
		const def = seriesDefs.find((entry) => entry.name === params.seriesName);
		const period = params.name ?? '';
		const rawValue = resolveCompareSeriesPointValueAt(def?.values, params.dataIndex);
		if (rawValue == null) return `${period}<br/>${params.marker}${params.seriesName}：—`;
		const valueText = typeof formatSeriesValue === 'function' ? formatSeriesValue(def, rawValue) : String(rawValue);
		return `${period}<br/>${params.marker}${params.seriesName}：${valueText}`;
	},
});

export const buildMixedOrAxisCompareTooltip = ({
	chartTheme,
	useItemTrigger = false,
	axisPointer,
	axisFormatter,
	seriesDefs,
	formatSeriesValue,
}) =>
	useItemTrigger
		? buildMixedCompareItemTooltip(chartTheme, { seriesDefs, formatSeriesValue })
		: {
				...chartTheme.tooltip,
				trigger: 'axis',
				axisPointer,
				formatter: axisFormatter,
			};
